import { render } from "./ResponsiveAnchor.vue?vue&type=template&id=b1dc946e&scoped=true"
import script from "./ResponsiveAnchor.vue?vue&type=script&lang=js"
export * from "./ResponsiveAnchor.vue?vue&type=script&lang=js"

import "./ResponsiveAnchor.vue?vue&type=style&index=0&id=b1dc946e&scoped=true&lang=scss"

import exportComponent from "/var/www/vhosts/dindin.mombaby.kroutony.me/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1dc946e"]])

export default __exports__